import { createAction } from 'redux-act';

export const preFetch = createAction('Pre Fetch');
export const resetState = createAction('reset state');
export const removeBreakoutGroup = createAction('remove breakout group');
